// MSTEM-MODIFIED: Runtime shim adding 'vi' (Tiếng Việt) to the openblock-l10n
// supported-locales map. Drop-in replacement for `import locales from 'openblock-l10n'`
// used by src/components/language-selector/language-selector.jsx and src/lib/app-state-hoc.jsx.
//
// Background: openblock-l10n@3.15.20250608130541 commented vi out of supported-locales.js:66.
// Adding it here at runtime exposes 'Tiếng Việt' in the LanguageSelector dropdown and lets
// detectLocale(Object.keys(locales)) accept 'vi' as a valid value.

import baseLocales from 'openblock-l10n';

export default Object.assign({}, baseLocales, {
    vi: {name: 'Tiếng Việt'}
});
